module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAoCAYAAAACJPERAAABX0lEQVRYR+3YMUvDQBTA8f+ZGERcHJzFWXAXv4WDOAiS6dJmEusnECddU7kurSCIix+jH8DBUXByEV1EJKY+iTRFpZWcJRXxsgXe3S/3uHu8izLGHAANIKD6JwWOlDEmA7zqvYGQ5qhMEHynHIpS6kxEdrXWt7bpbzab857n5Ru0Nmzsd+ld0Frf2YJFfB++t0K11uqnYDFu1CYduVKH2qTcpddtJNyRcUdmWAZccXDF4R8VB2DyPRJw0uv1dur1+oNNFcpj+03ZPhBbNWa2kE38n+nwX5VSFyJyqZRaEZF1YKrSlYrIZhRF5wXSarU2RGTwXga3TW9Xa732dWJjTBdYLQNa39pEpBNFUTgE7QDblaDAdRAEy2EYPhdAu92eSdP0CliqCs3nPc2yrBbH8WOSJHO+7x8DW2VB6/R+mPgJuAEWgVkbcBzU1vkU/2s/OvIb8x4wPdbnlxv8Ahy+AUUKEci83809AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/login/img/phone.png
// module id = taWi
// module chunks = 1